import { ILmpBlock } from '@sky-it-livedata/livedata-sports-design-system';
import { IWidget } from '@sky-it-livedata-libraries/livedata-widget';

import { IGenericObject } from '../typings/common-types';
import { ICurrentDateTime, IMatchCurrentDateTime } from '../typings/match-hero';
import { useService } from '../components/hooks/useService';

import { isEmptyObject, getModelFromUseService } from './props-validator';

export const ModelHeroLmp = (
  matchHeroWidget: IWidget,
  initialModel: ILmpBlock,
  live: boolean = true,
  query: IGenericObject = {}
): ILmpBlock => {
  // QUERY for LMP HERO
  const { model } = useService({
    live,
    query,
    widget: matchHeroWidget,
    initialValue: initialModel,
  });

  return getModelFromUseService(model);
};

export const ModelCurrentDateTime = (
  currentDatetimeWidget: IWidget,
  live: boolean = false,
  query: IGenericObject = {}
): string | null => {
  // QUERY for CURRENT DATE/TIME
  const { model } = useService({
    live,
    query,
    widget: currentDatetimeWidget,
  });

  return model?.query?.data?.getCurrentTime?.currentTime ?? null;
};

export const mergePayload = (
  heroLmp: ILmpBlock,
  matchCurrentDateTime: string,
  externalInterval: number = 0
): ILmpBlock => ({
  ...heroLmp,
  match: {
    ...heroLmp.match,
    matchCurrentDateTime,
    externalInterval, // New DS TIMER for MATCH TIMING
  },
});

export const render = (
  heroLmp: ILmpBlock,
  matchCurrentDateTime: string,
  externalInterval: number,
  updatePayload: Function
) => {
  if (!isEmptyObject(heroLmp) && heroLmp.match && matchCurrentDateTime) {
    updatePayload(mergePayload(heroLmp, matchCurrentDateTime, externalInterval));

    // console.log('MatchHeroHelpers', 'Wrapper.render', {
    //   heroLmp,
    //   matchCurrentDateTime,
    //   externalInterval,
    // });
  }
};

export const fromDateToSeconds = (dateISOString: string) =>
  new Date(dateISOString).setTime(new Date(dateISOString).getTime()) / 1000;

export const computeMatchCurrentDateTime = (
  timeDiffServerToClientRef: React.MutableRefObject<ICurrentDateTime>
): IMatchCurrentDateTime => {
  const systemDateTime: string = new Date().toISOString();
  const systemDateTimeSeconds: number = fromDateToSeconds(systemDateTime);
  const matchCurrentDateTime: string = new Date(
    (systemDateTimeSeconds - timeDiffServerToClientRef.current.timeDiff) * 1000
  ).toISOString();
  const matchCurrentDateTimeSeconds: number = fromDateToSeconds(matchCurrentDateTime);

  // console.log('MatchHeroHelpers', 'Wrapper.computeMatchCurrentDateTime', {
  //   timeDiffServerToClientRef: timeDiffServerToClientRef.current,
  //   matchCurrentDateTime,
  //   matchCurrentDateTimeSeconds,
  // });
  return {
    matchCurrentDateTime,
    matchCurrentDateTimeSeconds,
  };
};

export const chooseMatchCurrentDateTime = (
  statusStartDateTime: string,
  timeDiffServerToClientRef: React.MutableRefObject<ICurrentDateTime>,
  interval: number,
  updateInterval: Function
) => {
  // Choose if REMOTE DATE/TIME is reliable (comparing it to STATUS START DATE/TIME)
  const statusStartDateTimeSeconds = fromDateToSeconds(statusStartDateTime);
  // Execute only ONCE -> interval === 0
  if (interval === 0 && statusStartDateTimeSeconds > timeDiffServerToClientRef.current.remoteCurrentDateTimeSeconds) {
    console.warn('MatchHeroHelpers', 'Wrapper.chooseMatchCurrentDateTime', 'Negative matchTime', {
      timeDiffServerToClientRef: timeDiffServerToClientRef.current,
      statusStartDateTime,
      statusStartDateTimeSeconds,
      interval,
    });

    // If NOT, LOCAL DEVICE DATE/TIME will be used for TIMING!
    timeDiffServerToClientRef.current = {
      ...timeDiffServerToClientRef.current,
      remoteCurrentDateTime: timeDiffServerToClientRef.current.systemCurrentDateTime,
      remoteCurrentDateTimeSeconds: timeDiffServerToClientRef.current.systemCurrentDateTimeSeconds,
      timeDiff: 0,
    };

    // Force INTERVAL useEffect()
    updateInterval(interval + 0.001);
  }
};
